// extracted by mini-css-extract-plugin
export var cdFaqCard = "faq-card-module--cd-faq-card--84d29";
export var cdFaqCardContent = "faq-card-module--cd-faq-card-content--a221f";
export var cdFaqCardImg = "faq-card-module--cd-faq-card-img--547e7";